import type { ChatEvent } from '@cruz/shared';

/**
 * Server-sent events of POST /api/chat. EventSource only does GET, so the stream is
 * read by hand: blocks separated by a blank line, each with one `data: {json}` line.
 */
export async function* readChatEvents(body: ReadableStream<Uint8Array>): AsyncGenerator<ChatEvent> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const { value, done } = await reader.read();
    // stream: true keeps multi-byte characters split across chunks ("ñ", "á") intact
    buffer += decoder.decode(value, { stream: !done });
    let end: number;
    while ((end = buffer.indexOf('\n\n')) >= 0) {
      const block = buffer.slice(0, end);
      buffer = buffer.slice(end + 2);
      const event = parseBlock(block);
      if (event) yield event;
    }
    if (done) {
      const event = parseBlock(buffer);
      if (event) yield event;
      return;
    }
  }
}

function parseBlock(block: string): ChatEvent | null {
  const data = block
    .split('\n')
    .filter((l) => l.startsWith('data:'))
    .map((l) => l.slice(5).trimStart())
    .join('\n');
  if (!data) return null;
  try {
    return JSON.parse(data) as ChatEvent;
  } catch {
    return null;
  }
}
